import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import { FT_ASSET_REQUEST_PATH } from "constants/request";

import { ERROR_TYPES } from "constants/common";

import classes from "./ClientError.module.scss";

export const ClientError = () => {
  const { customerKey } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const robotImgUri = `${FT_ASSET_REQUEST_PATH}default/robot-error.svg`;

  const error = searchParams.get("error");

  const backHandler = () => {
    navigate(-1);
  };

  const handleErrorOutput = () => {
    if (!!error && error === ERROR_TYPES.NOT_FOUND) {
      return (
        <div>
          <p>The page you are looking for cannot be found.</p>
          <p>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
            <Link to="." onClick={backHandler}>
              Go Back
            </Link>
          </p>
        </div>
      );
    } else {
      return (
        <>
          <p>
            The site you are trying to access, which is managed by FirsTech
            Inc., could be experiencing a service outage or planned downtime to
            update system configurations.
          </p>
          <p>
            We track these errors automatically, but if the problem persists
            please contact your support team.
          </p>
          <p>
            <Link to={`/${customerKey?.toLocaleLowerCase()}/`}>Home</Link>
          </p>
        </>
      );
    }
  };

  return (
    <>
      <div className={classes.ErrorPage}>
        <div className={classes.Content}>
          <div className={classes.ErrorMessageContainer}>
            <div>
              <h1>Oops...</h1>
              <h2>Sorry, something went wrong.</h2>
              <div className={classes.Messages}>
                {handleErrorOutput()}
                <p>
                  <strong>Apologies and please try again.</strong>
                </p>
              </div>
            </div>
          </div>
          <div className={classes.ImageContainer}>
            <img src={robotImgUri} alt="Tobi, the FirsTech, robot is sad." />
          </div>
        </div>
        <div className={classes.FooterContainer}>
          <div className={classes.FooterBar}></div>
          <div className={classes.LogoContainer}></div>
        </div>
      </div>
    </>
  );
};
